import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=1c631798&scoped=true&lang=pug&"
import script from "./ShareButton.vue?vue&type=script&lang=js&"
export * from "./ShareButton.vue?vue&type=script&lang=js&"
import style0 from "./ShareButton.vue?vue&type=style&index=0&id=1c631798&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c631798",
  null
  
)

export default component.exports